import { Injectable } from "@angular/core";
import { Member } from "src/models/careplus-new-customer";
import { FeeDetails } from "src/models/fee-details";

export interface FeeCalculationResult {
  basePremium: number;
  totalIssueFee: number;
  policyFee: number;
  totalAmount: number;
  amountToBePaid: number;
}

@Injectable({
  providedIn: "root",
})
export class CareplusFeeCalculationService {
  calculateFees(
    members: Member[],
    feeDetails: FeeDetails,
    discountAmount: number = 0,
  ): FeeCalculationResult {
    if (!members || !feeDetails) {
      return {
        basePremium: 0,
        totalIssueFee: 0,
        policyFee: 0,
        totalAmount: 0,
        amountToBePaid: 0,
      };
    }
    const spouseCount = members.filter(
      (m) => m.relationType === "Spouse",
    ).length;

    const childrenCount = members.filter(
      (m) => m.relationType === "Child",
    ).length;

    const totalMembers = spouseCount + childrenCount + 1;
    const basePremium =
      feeDetails.mainMember +
      feeDetails.spouse * spouseCount +
      feeDetails.children * childrenCount +
      feeDetails.personalAccidentPerMember * totalMembers;
    const contributorFee = feeDetails.contributorFee;
    const beneficiaryIssueFee =
      feeDetails.contributorFee * (spouseCount + childrenCount);
    const totalIssueFee = contributorFee + beneficiaryIssueFee;
    const policyFee = feeDetails.supervisionFee;
    const totalAmount = basePremium + totalIssueFee + policyFee;
    const amountToBePaid = totalAmount - (discountAmount || 0);
    return {
      basePremium,
      totalIssueFee,
      policyFee,
      totalAmount,
      amountToBePaid,
    };
  }
}
